import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as WidgetPagesActions from './widget-pages.actions'
import { WidgetPagesEntity, OldWidgetsEntity } from './widget-pages.models'

export const WIDGET_PAGES_FEATURE_KEY = 'widget-pages'

export interface WidgetPagesState extends EntityState<WidgetPagesEntity> {
  selectedId?: string | number
  loaded: boolean
  oldWidgets: OldWidgetsEntity[]
  editCreateWidgetPageLoaded: boolean
}

export interface WidgetPagesPartialState {
  readonly [WIDGET_PAGES_FEATURE_KEY]: WidgetPagesState
}

export const widgetPagesAdapter: EntityAdapter<WidgetPagesEntity> = createEntityAdapter<WidgetPagesEntity>({
  selectId: (model) => model.uuid,
})

export const initialWidgetPagesState: WidgetPagesState = widgetPagesAdapter.getInitialState({
  loaded: false,
  oldWidgets: [],
  editCreateWidgetPageLoaded: true,
})

const reducer = createReducer(
  initialWidgetPagesState,
  on(WidgetPagesActions.loadWidgetPages, (state) => ({
    ...state,
    loaded: false,
  })),
  on(WidgetPagesActions.loadWidgetPagesSuccess, (state, { widgetPages }) =>
    widgetPagesAdapter.setAll(widgetPages, { ...state, loaded: true }),
  ),
  on(WidgetPagesActions.loadOldWidgetsSuccess, (state, { old_widgets }) => ({ ...state, oldWidgets: old_widgets })),
  on(WidgetPagesActions.addWidgetPageSuccess, (state, { widgetPage }) => widgetPagesAdapter.addOne(widgetPage, state)),
  on(WidgetPagesActions.syncWidgetPageSuccess, (state, { widgetPage }) =>
    widgetPagesAdapter.upsertOne(widgetPage, state),
  ),
  on(WidgetPagesActions.updateWidgetPageSuccess, (state, { widgetPage }) =>
    widgetPagesAdapter.updateOne({ id: widgetPage.uuid, changes: widgetPage }, state),
  ),
  on(WidgetPagesActions.deleteWidgetPageSuccess, (state, { uuid }) => widgetPagesAdapter.removeOne(uuid, state)),
  on(WidgetPagesActions.selectWidgetPage, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(WidgetPagesActions.clearSelectedWidgetPage, (state) => ({
    ...state,
    selectedId: undefined,
  })),
  on(WidgetPagesActions.addWidgetPage, WidgetPagesActions.updateWidgetPage, (state) => ({
    ...state,
    editCreateWidgetPageLoaded: false,
  })),
  on(
    WidgetPagesActions.addWidgetPageSuccess,
    WidgetPagesActions.addWidgetPageFailure,
    WidgetPagesActions.updateWidgetPageSuccess,
    WidgetPagesActions.updateWidgetPageFailure,
    (state) => ({
      ...state,
      editCreateWidgetPageLoaded: true,
    }),
  ),
  on(WidgetPagesActions.clearWidgetPages, () => ({ ...initialWidgetPagesState })),
)

export function widgetPagesReducer(state: WidgetPagesState | undefined, action: Action) {
  return reducer(state, action)
}
